/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The ready-to-encode JSON string for the device setup QR code (fully managed device / Device Owner). The backend assembles it so that clients only need to render the QR code. The admin extras contract is owned by the app (`Constants.ProvisioningExtras` in `mobile/elooperator/.../Constants.kt`).
 * @export
 * @interface ProvisioningPayload
 */
export interface ProvisioningPayload {
    /**
     * 
     * @type {string}
     * @memberof ProvisioningPayload
     */
    payload: string;
}

/**
 * Check if a given object implements the ProvisioningPayload interface.
 */
export function instanceOfProvisioningPayload(value: object): value is ProvisioningPayload {
    if (!('payload' in value) || value['payload'] === undefined) return false;
    return true;
}

export function ProvisioningPayloadFromJSON(json: any): ProvisioningPayload {
    return ProvisioningPayloadFromJSONTyped(json, false);
}

export function ProvisioningPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProvisioningPayload {
    if (json == null) {
        return json;
    }
    return {
        
        'payload': json['payload'],
    };
}

export function ProvisioningPayloadToJSON(json: any): ProvisioningPayload {
    return ProvisioningPayloadToJSONTyped(json, false);
}

export function ProvisioningPayloadToJSONTyped(value?: ProvisioningPayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payload': value['payload'],
    };
}

